import { EnterDetailsFieldset } from 'components/enter_details/form_field_spacing'
import Field from 'components/custom_fields/field'

const CustomFields = ({ fields = [], onChange }) => {
  if (!fields.length) return null

  return (
    <EnterDetailsFieldset>
      {
        fields.map(({
          id, format, name, required, value, answer_choices: answers, include_other: includeOther
        }, index) => (
          <Field
            key={id}
            index={index}
            format={format}
            name={name}
            required={required}
            value={value}
            answers={answers}
            includeOther={includeOther}
            onChange={onChange}
          />
        ))
      }
    </EnterDetailsFieldset>
  )
}

export default CustomFields
